var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "el-row",
            { attrs: { type: "flex" } },
            [
              _c(
                "el-col",
                { attrs: { span: 18 } },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", gutter: 4 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "Trạng thái" },
                              on: { change: _vm.handleChangeFilterStatus },
                              model: {
                                value: _vm.filterStatusPackage,
                                callback: function ($$v) {
                                  _vm.filterStatusPackage = $$v
                                },
                                expression: "filterStatusPackage",
                              },
                            },
                            _vm._l(
                              _vm.packageDelActive,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", gutter: 4, justify: "end" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 9 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "medium",
                                icon: "el-icon-plus",
                              },
                              on: { click: _vm.handleOpenCreateDialog },
                            },
                            [_vm._v("\n              Thêm mới\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px", "margin-bottom": "18px" } },
        [_vm._t("default")],
        2
      ),
      _c(
        "DefaultLayoutDialog",
        {
          attrs: {
            title: "Thêm một gói mới",
            width: "30%",
            isOpen: _vm.visibleDialog.createForm,
          },
          on: { "update:isOpen": _vm.setCreateForm },
        },
        [
          _c("FormCreateDialogPackage", {
            ref: "FormCreateDialogPackage",
            on: { closeDialogCreate: _vm.setCreateForm },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }